import "clsx";
import { P as pop, N as push } from "../../../chunks/index.js";
import { L as Loading, N as Navbar, B as Button, F as Footer } from "../../../chunks/Loading.js";
function Privacy_md($$payload) {
  $$payload.out += `<!----># Privacy Policy <span class="font-display opacity-70">**Last updated 07/12/2023**</span> ## 1. Introduction

Welcome to Glimmr, a product of Glimmr LLC ("we", "us", "our"). We understand the importance of your privacy and we are
committed to protecting your personal data. This Privacy Policy will explain how our organization uses the personal data
we collect from you when you use our application.

## 2. What data do we collect?

Glimmr collects the following data:

-   Information regarding your monitor settings and adjustments you make within the application.
-   Usage statistics to improve our services.

Please note that we do not collect any sensitive personal data or information that can be used to identify you
personally.

## 3. How do we collect your data?

We collect data and process data when you:

-   Use or view our application via your device's analytics.
-   Voluntarily provide feedback on any of our message boards or via email.

## 4. How will we use your data?

We collect your data so that we can:

-   Improve our services.
-   Understand how you use our app to tailor it to customer needs.

## 5. How do we store your data?

Your data is securely stored on Firebase.

We will keep your usage data indefinitely or until we are asked to delete it.

## 6. What are your data protection rights?

Glimmr would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the
following:

-   The right to access – You have the right to request copies of your personal data.
-   The right to rectification – You have the right to request that we correct any information you believe is inaccurate.
-   The right to erasure – You have the right to request that we erase your personal data, under certain conditions.
-   The right to restrict processing – You have the right to request that we restrict the processing of your personal
    data, under certain conditions.
-   The right to object to processing – You have the right to object to our processing of your personal data, under
    certain conditions.
-   The right to data portability – You have the right to request that we transfer the data that we have collected to
    another organization, or directly to you, under certain conditions.

## 7. Privacy policies of other websites

Our application may contain links to other websites. Our privacy policy applies only to our application, so if you click
on a link to another website, you should read their privacy policy.

## 8. Changes to our privacy policy

Glimmr keeps its privacy policy under regular review and places any updates on this web page. This privacy policy was
last updated on 07/12/2023.

## 9. How to contact us

If you have any questions about Glimmr's privacy policy, the data we hold on you, or you would like to exercise one of
your data protection rights, please do not hesitate to contact us at [support@glimmr.app](mailto:support@glimmr.app).

## 10. How to contact the appropriate authorities

Should you wish to report a complaint or if you feel that Glimmr has not addressed your concern in a satisfactory
manner, you may contact the Florida Department of Legal Affairs.

**Office of Attorney General**
State of Florida
The Capitol PL-01
Tallahassee, FL 32399-1050

**Telephone**
(850) 414-3300

For online submissions, visit the official website of the Florida Attorney General's Office and navigate to the "
Consumer Protection" section to find information on how to file a complaint. The URL for the website
is: [https://myfloridalegal.com/](https://myfloridalegal.com/)`;
}
function _page($$payload, $$props) {
  push();
  Loading($$payload);
  $$payload.out += `<!----> <div class="fade-in bg-white">`;
  Navbar($$payload, {});
  $$payload.out += `<!----> <div class="container max-w-screen-lg mx-auto py-12 px-12 space-y-4"><a href="/">`;
  Button($$payload, {
    startIcon: "mdi:arrow-back",
    label: "Home",
    size: 2
  });
  $$payload.out += `<!----></a> `;
  Privacy_md($$payload);
  $$payload.out += `<!----></div> `;
  Footer($$payload);
  $$payload.out += `<!----></div>`;
  pop();
}
export {
  _page as default
};
